import { Container } from '@components/Container'
import { ActivityLogsTable } from '../ActivityLogsTable'
import { columns } from './columns'
import { PublishActivityModalProps } from './interface'

function PublishActivityModal({
  data,
  isLoading,
  handleFetchNextPage,
}: PublishActivityModalProps) {
  return (
    <Container className='!w-[610px] !p-5'>
      <Container.Title className='text-center' showBackBtn={false}>
        ประวัติการเผยแพร่เนื้อหา
      </Container.Title>
      <div className='max-h-[370px] overflow-y-auto'>
        <ActivityLogsTable
          data={data}
          isLoading={isLoading}
          columns={columns}
          onWayPointEnter={handleFetchNextPage}
        />
      </div>
    </Container>
  )
}

export default PublishActivityModal
